var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('AsiPageTitle',{attrs:{"title":_vm.$t('cart.plural'),"icon":_vm.icons.carts}}),_c('CartList',{attrs:{"memory-key":"admin-carts"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }